module.exports = __webpack_public_path__ + "img/20.5dfbeb32.png";